import RelatedPropertiesCardList, {
  RelatedPropertiesCardListProps
} from '@portalterreno/nextjs-client/portalterreno/components/RelatedPropertiesCardList';
import Button from '@portalterreno/react-ui-core/Button';
import ModalMobile, {
  ModalMobileProps
} from '@portalterreno/react-ui-core/ModalMobile';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';

import ButtonsWrapper from '../../RelatedPropertiesLeadModal/Mobile/ButtonsWrapper';
import CardListWrapper from '../CardListWrapper';
import Header from '../Header';
import ModalContent from '../ModalContent';

export type MobileProps = Omit<
  ModalMobileProps,
  'children' | 'onBackdropClick' | 'title'
> &
  Pick<RelatedPropertiesCardListProps, 'relatedProperties'>;

const Mobile: FC<MobileProps> = ({ relatedProperties, onClose, ...rest }) => {
  const { t } = useTranslation(['common']);

  return (
    <ModalMobile
      {...rest}
      onClose={onClose}
      onBackdropClick={onClose}
      title='Mensaje enviado'
    >
      <ModalContent>
        <Header />
        <CardListWrapper>
          <RelatedPropertiesCardList
            relatedProperties={relatedProperties}
            withLinks
          />
        </CardListWrapper>
      </ModalContent>
      <ButtonsWrapper>
        <Button
          color='midnight'
          onClick={onClose}
        >
          {t('common:close')}
        </Button>
      </ButtonsWrapper>
    </ModalMobile>
  );
};

export default Mobile;
